// Libraries import
import React from 'react';
import ReactDOM from 'react-dom/client';

// Styling import
import './index.scss';

// Components import
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <App />
);